import { apiReports } from '@/api'
import type {
  MedComplex,
  MedComplexList,
  MedComplexModel,
  MedComplexCertificate,
  MedComplexQueryParams,
  CertificateCheckInfoList,
} from '@/api/models/medcomplex'
import type { BaseQueryParams } from '@/types'

export const medreportsApi = apiReports.injectEndpoints({
  endpoints: (builder) => ({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getMedReports: builder.query<any, any>({
      async queryFn(params, api, _extraOptions, baseQuery) {
        const state = api.getState() as RootState
        return await baseQuery({
          url: `${state.app.baseUrl?.slice(0, -3)}/v2/cards`,
          method: 'GET',
          params: params,
        })
      },
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getMedReport: builder.query<any, any>({
      query: (id) => ({
        url: `/cards/${id}`,
        method: 'GET',
      }),
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getMedReportsCount: builder.query<any, any>({
      query: (query) => ({
        url: `/cards/count` + `?query=${JSON.stringify(query)}`,
        method: 'GET',
        //params,
      }),
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getNorms: builder.query<any, void>({
      query: () => ({
        url: `/check-norms`,
        method: 'GET',
        //params,
      }),
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getFileByURL: builder.query<any, string>({
      query: (url) => ({
        url: `${url}`,
        method: 'GET',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        responseHandler: async (response: any) =>
          window.URL.createObjectURL(await response.blob()),
      }),
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getExelReport: builder.query<any, any>({
      query: (query) => ({
        url: '/cards/excel' + `?query=${JSON.stringify(query)}`,
        method: 'POST',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // responseHandler: async (response: any) =>
        //   window.URL.createObjectURL(await response.blob()),
      }),
    }),

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getReferrals: builder.query<any, any>({
      query: (query) => ({
        url: `/cards/referrals` + `?query=${JSON.stringify(query)}`,
        method: 'GET',
      }),
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getDriverCertificates: builder.query<any, any>({
      query: (value) => ({
        url: `/cards/certificates${value ? `?value=${value}` : ''}`,
        method: 'GET',
      }),
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getDriverDeviations: builder.query<any, void>({
      query: () => ({
        url: `/deviations`,
        method: 'GET',
      }),
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getMedJournalReports: builder.query<any, any>({
      query: (query) => ({
        url:
          `/cards/med-journals` +
          `?page=${query?.page}&per_page=${query?.per_page}`,
        method: 'GET',
        //params,
      }),
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getArchiveUrl: builder.query<any, any>({
      query: ({ id }) => ({
        url: `/cards/${id}/archive-url`,
        method: 'GET',
      }),
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getMedComplexNumbersList: builder.query<any, any>({
      query: (params) => ({
        url: `/cards/medical-complexes?per_page=10`,
        method: 'GET',
        params,
      }),
    }),
  }),
})

export const {
  useLazyGetMedReportsQuery,
  useLazyGetNormsQuery,
  useLazyGetFileByURLQuery,
  useLazyGetExelReportQuery,
  useLazyGetReferralsQuery,
  useLazyGetMedReportsCountQuery,
  useLazyGetDriverCertificatesQuery,
  useLazyGetDriverDeviationsQuery,
  useLazyGetMedJournalReportsQuery,
  useLazyGetMedReportQuery,
  useLazyGetArchiveUrlQuery,
  useLazyGetMedComplexNumbersListQuery,
} = medreportsApi
